import React from 'react'
import ItemCardMore from './ItemCardMore'



class MoreItems extends React.Component {
    render() {
        const { next, previous, header } = this.props


        return(
            <>
                <h2>{header}</h2>
                { previous && <ItemCardMore data={previous } />}
                { next && <ItemCardMore data={next} /> }
            </>
        )
    }
}


export default MoreItems

